const OHIP_LENGTH = 10;

/*
 * Validates a given OHIP number
 * Must be exactly 10 digits, numeric only, no spaces or special characters
 *
 * @param {string} value - The OHIP number
 * @returns {boolean} Whether or not the given OHIP number is valid
 */
export const isOhipValid = (value: string): boolean => {
  if (!value || !value.trim()) {
    return false;
  }
  // Remove all non-numeric characters
  const digitsOnly = value.replace(/\D/g, "");
  // Must be exactly 10 digits
  return digitsOnly.length === OHIP_LENGTH && /^\d{10}$/.test(digitsOnly);
};
